module.exports = __webpack_public_path__ + "img/mushamaru_1.ff89fffa.png";